module.exports = __webpack_public_path__ + "static/img/ed56ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/txgg_zbfl.png
// module id = 631
// module chunks = 2